export enum BiometricTypeEnum {
	None,
	Fingerprint,
	Face,
}
